<template>
  <div>
    <div class="page-title title">
      <span>DANH SÁCH LÔ - HSD</span>
    </div>
    <div class="main-content-layout">
      <div class="d-flex justify-content-between mb-3">
        <div class="d-flex justify-content-between">
          <el-popover
            placement="bottom-start"
            width="680px"
            trigger="click"
            v-model="filterVisible"
          >
           <!-- btn -->
            <el-button class="n-btn" slot="reference" type="info">
              <div class="n-icon">
                <i class="mdi mdi-filter-outline"></i>
                Bộ lọc
              </div>
            </el-button>
            
            <div class="mr-2">
              <div class="row d-flex align-items-center my-2 ">
                <span class="col-4 mt-2">Ngày sản xuất:</span>
                <el-date-picker
                  class="el col-8"
                  type="daterange"
                  align="right"
                  start-placeholder="Từ ngày"
                  end-placeholder="Đến ngày"
                  format="dd/MM/yyyy"
                  v-model="dateRangeManufacture"
                  :clearable="false">
                </el-date-picker>
              </div>
              <div class="row d-flex align-items-center my-2 ">
                <span class="col-4 mt-2">Hạn sử dụng:</span>
                <el-date-picker
                  class="el col-8"
                  type="daterange"
                  align="right"
                  start-placeholder="Từ ngày"
                  end-placeholder="Đến ngày"
                  format="dd/MM/yyyy"
                  v-model="dateRangeExpiration"
                  :clearable="false">
                </el-date-picker>
              </div>
            </div>
            <!-- list btn end filter -->
            <div class="row pr-2 d-flex my-2 justify-content-end">
              <el-button class="n-btn" @click="filterVisible = false"
                >Huỷ</el-button
              >
              <el-button class="n-btn" type="danger" plain @click="clearFilter"
                >Xóa bộ lọc</el-button
              >
              <el-button @click="searchFilter" class="n-btn" type="primary">Áp dụng bộ lọc</el-button>
            </div>
            <!-- <div class="btn-filter" style="display: flex; flex-direction: row-reverse">
              <BaseButton
                @click="searchFilter"
                class="ml-2"
              >Áp dụng bộ lọc</BaseButton>
              <BaseButton
                variant="danger"
                @click="clearFilter"
                class="ml-2"
              >Xóa bộ lọc</BaseButton>
              <BaseButton
                variant="outline"
                @click="filterVisible = false"
                class="ml-2"
              >Huỷ</BaseButton>
            </div> -->
          </el-popover>
          <el-input class="ml-2" @keyup.enter.native="searchFilter" v-model="dataSearch" style="width:340px" placeholder="Tìm kiếm" clearable>
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
      </div>

      <div class="table-data">
        <!-- <loading v-if="loading"></loading> -->
        <b-table
          class="n-table"
          v-loading="loading"
          :fields="fieldBatch"
          :items="dataBatch"
          :per-page="perPage"
          :currentPage="currentPage"
          show-empty
          emptyText="Không có dữ liệu phù hợp"
        >
          <template #empty="scope">
            <h3 class="text-center my-5 text-secondary"><b>{{ scope.emptyText }}</b></h3>
          </template>

          <template #cell(batchCode)="data">
            <a 
              class="text-primary" 
              :href="`/items/batch-detail/${data.item.batchCode}/${data.item.sku}`"
            >
              {{ data.item.batchCode}}
            </a>
          </template>

          <template #cell(manufactureDate)="data">
            <span>
              {{ data.item.manufactureDate | formatDate }}
            </span>
          </template>

          <template #cell(expirationDate)="data">
            <span>
              {{ data.item.expirationDate | formatDate }}
            </span>
          </template>
        </b-table>
      </div>
      <div class="pagination-wrapper">
        <b-pagination
          align="right"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
        >
        </b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import VueCookies from 'vue-cookies'
import { ItemService } from "@/services/nextshop/item.service";
import moment from "moment";
import { getStorageItemNotParse } from '@/utils/auth'
import {
  getLocationID
} from "../../utils/auth";
export default {
  data() {
    return {
      locationId: VueCookies.get("LID"),
      LID: getLocationID(),
      loading: false,
      filterVisible: false,
      inventoryId: localStorage.getItem("inventoryID"),
      paramsGetListBatch: {
        queryString: "",
        limit: "",
        lastIndex: "",
        sort: [
          {
            SortField: "CREATED_DATE",
            SortValue: "DESC"
          },
          {
            SortField: "EXPIRATION_DATE",
            SortValue: "ASC"
          }
        ]
        
      },
      dataSearch: "",
      fieldBatch: [
        {
          key: "batchCode",
          label: "Mã Lô",
          thClass: "text-left"
        },
        {
          key: "manufactureDate",
          label: "Ngày sản xuất",
        },
        {
          key: "expirationDate",
          label: "Ngày hết hạn",
        },
        {
          key: "itemName",
          label: "Tên sản phẩm",
        },
        {
          key: "variationName",
          label: "Tên phiên bản",
        },
        {
          key: "sku",
          label: "SKU",
        },
        {
          key: "quantity",
          label: "Tồn kho",
          thClass: "text-center",
          tdClass: "text-center"
        },
      ],
      dataBatch: [],
      // inventoryTotalQuantity: [],
      dataInventory: [],
      currentPage: 1,
      perPage: 20,
      dateRangeManufacture: {},
      dateRangeExpiration: []
    };
  },

  computed: {
    rows() {
      return this.dataBatch.length
    },

    clearText() {
      return this.dataSearch.length != 0
    }
  },

  created() {
    this.paramsGetListBatch.queryString = "{locationId} == '''" + this.locationId + "'''"
    this.getData()
  },

  watch: {
    dataSearch: _.debounce(function() {
      if (this.dataSearch == '') {
          this.searchFilter()
      }
    },700),
  },

  methods: {

    clearFilter() {
      this.dateRangeManufacture = {}
      this.dateRangeExpiration = {}
      this.filterVisible = false
      this.paramsGetListBatch.queryString = "{locationId} == '''" + this.locationId + "'''"
      this.getData()
    },

    async searchFilter() {
      this.loading = true
      const queryArray = [];
      queryArray.push("{locationId} == '''" + this.locationId + "'''");

      if(this.dataSearch !== '') {
        queryArray.push(`{sku}=='''${this.dataSearch.trim()}''' or {batchCode}=='''${this.dataSearch.trim()}''' or {variationName}=='''${this.dataSearch.trim()}''' or {itemName}=='''${this.dataSearch.trim()}'''`)
      }
      
      if (this.dateRangeManufacture[0] != undefined || this.dateRangeManufacture[1] != undefined) {
        const dateFrom = moment(this.dateRangeManufacture[0]).format("YYYY-MM-DD") + `T00:00:00.000Z`
        const dateTo = moment(this.dateRangeManufacture[1]).format("YYYY-MM-DD") + `T23:59:59.000Z`
        queryArray.push(`{manufactureDate} range [#${dateFrom}#, #${dateTo}#]`)
      }

      if (this.dateRangeExpiration[0] != undefined || this.dateRangeExpiration[1] != undefined) {
        const dateFrom = moment(this.dateRangeExpiration[0]).format("YYYY-MM-DD") + `T00:00:00.000Z`
        const dateTo = moment(this.dateRangeExpiration[1]).format("YYYY-MM-DD") + `T23:59:59.000Z`
        queryArray.push(`{expirationDate} range [#${dateFrom}#, #${dateTo}#]`)
      }

      this.filterVisible = false
      this.paramsGetListBatch.queryString = queryArray.join(' and ')
      await this.getData(this.paramsGetListBatch.queryString)
      this.loading = false
    },

    async getData() {
      try {
        this.loading = true
        const response = await ItemService.getBatchData(this.paramsGetListBatch)
        this.loading = false
        if (response.success) {
          this.dataBatch = response.data.data.productBatchModelFlat

          const inventoryID = getStorageItemNotParse("inventoryID")
          if(this.dataBatch.length > 0){
            this.dataBatch.map((item, index)=>{
              if(item.inventoryData.length > 0){
                item.inventoryData.map((_item)=>{
                  if(_item.inventoryId === inventoryID){
                    this.dataBatch[index].quantity = _item.quantity
                  }
                })
              }
            })
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    
  }
}
</script>

<style lang="scss">
.search-input input{
  height: 44px;
}
</style>

<style scoped lang="scss">
.title {
  padding-bottom: 18px;
  font-size: 20px;
  line-height: 30px;
}

.input-search {
  // position: relative;
  top: 0;
  width: 300px;
  padding: 0 0 10px 0;

}

::v-deep .__input_wrap {
  background: #f2f2f2;
  padding: 8px !important;
  .__input_controls {
    background: #f2f2f2;
  }
  input.__input {
    background: #f2f2f2;
  }
  .__input::placeholder {
    color: #666666;
  }
  :last-child {
    padding: 0;
  }
}
</style>